module.exports = __webpack_public_path__ + "img/antt-header.9c1e6023.png";